import { isSafeguardHost } from "@/assets/js/safeguardSite";

const finbridgeRoutes = [
  {
    path: "/",
    name: "Home",
    meta: {
      gtm: "메인페이지"
    },
    // 세이프가드 홈페이지(safeguard.finbridge.co.kr)는 세이프가드·금융사기방지 소개 페이지를 첫 화면으로 쓴다
    component: () =>
      isSafeguardHost()
        ? import(/* webpackChunkName: "service" */ "@/pages/service/SafeGuard.vue")
        : import(/* webpackChunkName: "home" */ "@/pages/home/index.vue")
  },
  {
    path: "/company",
    name: "Company",
    meta: {
      menuIndex: 0,
      gtm: "회사소개"
    },
    component: () => import(/* webpackChunkName: "Company" */ "@/pages/Company.vue")
  },
  {
    path: "/service/safeguard",
    name: "SafeGuard",
    meta: {
      menuIndex: 1,
      gtm: "서비스>세이프가드"
    },
    component: () => import(/* webpackChunkName: "service" */ "@/pages/service/SafeGuard.vue")
  },
  // safe billing eos
  // {
  //   path: "/service/safebilling",
  //   name: "SafeBilling",
  //   meta: {
  //     menuIndex: 1
  //   },
  //   component: () => {
  //   return import(/* webpackChunkName: "service" */ "@/pages/service/SafeBilling.vue")
  //   },
  //   meta: {
  //     gtm: "서비스>세이프빌링"
  //   }
  // },
  {
    path: "/service/passprime",
    name: "PassPrime",
    meta: {
      menuIndex: 1,
      gtm: "서비스>PASS프라임"
    },
    component: () => import(/* webpackChunkName: "service" */ "@/pages/service/PassPrime.vue")
  },
  {
    path: "/privacy",
    name: "Privacy",
    meta: {
      gtm: "개인정보처리방침"
    },
    component: () => import(/* webpackChunkName: "privacy" */ "@/pages/Privacy.vue")
  },
  {
    path: "/career/culture",
    name: "CareerCulture",
    meta: {
      menuIndex: 2,
      gtm: "인재채용>핀브릿지 문화"
    },
    component: () => import(/* webpackChunkName: "career" */ "@/pages/career/Culture.vue")
  },
  // {
  //   path: "/career/people",
  //   name: "CareerPeople",
  //   meta: {
  //     menuIndex: 2
  //   },
  //   component: () => import(/* webpackChunkName: "career" */ "@/pages/career/People.vue")
  // },
  {
    path: "/career/jobs",
    meta: {
      gtm: "인재채용>채용 공고"
    },
    component: () => import(/* webpackChunkName: "career" */ "@/pages/career/Jobs.vue"),
    children: [
      {
        path: "",
        name: "CareerList",
        meta: {
          menuIndex: 2,
          gtm: "인재채용>채용 공고>채용리스트"
        },
        component: () => import(/* webpackChunkName: "career"  */ "@/pages/career/List.vue")
      },
      {
        path: ":recruitNo",
        name: "CareerDetail",
        meta: {
          menuIndex: 2,
          gtm: "인재채용>채용 공고>공고 상세"
        },
        component: () => import(/* webpackChunkName: "career"  */ "@/pages/career/Detail.vue")
      }
    ]
  },
  // {
  //   path: "/notice",
  //   component: () => import(/* webpackChunkName: "notice" */ "@/pages/notice/index.vue"),
  //   children: [
  //     {
  //       path: "",
  //       name: "NoticeList",
  //       meta: {
  //         menuIndex: 3
  //       },
  //       component: () => import(/* webpackChunkName: "notice"  */ "@/pages/notice/List.vue")
  //     },
  //     {
  //       path: ":noticeNo",
  //       name: "NoticeDetail",
  //       meta: {
  //         menuIndex: 3
  //       },
  //       component: () => import(/* webpackChunkName: "notice"  */ "@/pages/notice/Detail.vue")
  //     }
  //   ]
  // },
  // {
  //   path: "/partnership",
  //   name: "PartnerShip",
  //   meta: {
  //     menuIndex: 4
  //   },
  //   component: () => import(/* webpackChunkName: "partnership"  */ "@/pages/partnership/index.vue")
  // }
];
export default finbridgeRoutes;
